import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import Slide from '@material-ui/core/Slide';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide ref={ref} direction="up" {...props} />;
});

const useStyles = makeStyles((theme) => ({
  container: {
    backdropFilter: 'blur(5px)'
  },
  meeting: {
    color: '#19CAFF',
    fontWeight: 'bold',
    fontSize: 12
  },
  closeButton: {
    textAlign: 'right',
    cursor: 'pointer'
  },
  company: {
    fontSize: 32,
    color: '#002380',
    marginBottom: 20
  },
  subTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 20
  },
  header: {
    textAlign: 'left'
  },
  details: {
    fontSize: 14,
    '& span': {
      textDecoration: 'underline'
    }
  },

  infos: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '85%'
  },
  text: {
    fontSize: 16,
    marginBottom: 15,
    marginRight: 35,
    width: '55%'
  },
  subInfos: {
    fontSize: 14,
    marginBottom: 20,
    '& span': {
      textDecoration: 'underline'
    }
  },
  paper: {
    padding: 30,
    minWidth: 700,
    width: 700
  },
  peerCompaniesInvestTitle: {
    fontSize: 14,
    textDecoration: 'underline',
    marginBottom: 10
  },
  companyInfos: {
    fontSize: 12
  },
  see: {
    fontSize: '16px',
    textTransform: 'Capitalize',
    fontWeight: 'bold',
    borderColor: '#002380',
    borderRadius: 0,
    marginRight: '1rem',
    minWidth: '145px'
  }
}));

const CompanyModal = ({ open, onClose }) => {
  const classes = useStyles();
  return (
    <div>
      <Dialog
        classes={{ paper: classes.paper, container: classes.container }}
        keepMounted
        maxWidth={false}
        onClose={onClose}
        open={open}
        TransitionComponent={Transition}>
        <div className={classes.closeButton}>
          <CloseIcon onClick={onClose} />
        </div>
        {/* Header */}
        <div className={classes.header}>
          <Typography className={classes.company} gutterBottom variant="h4">
            Fidelity (FMR)
          </Typography>
          <Typography className={classes.subTitle} gutterBottom variant="h6">
            Mutual Funds
          </Typography>
        </div>

        <div className={classes.infos}>
          <Typography className={classes.text} gutterBottom variant="body1">
            It is one of the largest asset managers in the world. FMR operates a
            brokerage firm, manages mutual funds, provides fund distribution and
            investment advice, retirement services, index funds and wealth
            management.
          </Typography>
          <div className={classes.details}>
            <Typography gutterBottom variant="subtitle2">
              <span>Location</span>: Boston (USA)
            </Typography>
            <Typography gutterBottom variant="subtitle2">
              <span>Date of creation</span>: 1946
            </Typography>
            <Typography gutterBottom variant="subtitle2">
              <span>Website</span>:{' '}
              <a href="http://www.praexo.com">www.fidelity.com</a>
            </Typography>
          </div>
        </div>
        <Typography
          className={classes.subInfos}
          gutterBottom
          variant="subtitle2">
          <span>Au M</span>: $2.5 trillion
        </Typography>
        <div className={classes.infos}>
          <div className={classes.peerCompanies}>
            <Typography
              className={classes.peerCompaniesInvestTitle}
              gutterBottom
              variant="subtitle2">
              Investement in peer companies
              <br />
              (% of share capital - date)
            </Typography>
            <Typography
              className={classes.companyInfos}
              display="block"
              gutterBottom
              variant="caption">
              Company A (2,3% - 2015)
            </Typography>
            <Typography
              className={classes.companyInfos}
              display="block"
              gutterBottom
              variant="caption">
              Company B (4,6% - 2017)
            </Typography>
            <Typography
              className={classes.companyInfos}
              display="block"
              gutterBottom
              variant="caption">
              Company C (7,8% - 2019)
            </Typography>
          </div>
          <Button
            className={classes.see}
            color="primary"
            onClick={onClose}
            variant="outlined">
            see feedback
          </Button>
        </div>
      </Dialog>
    </div>
  );
};

export default CompanyModal;
